import { render, staticRenderFns } from "./menuMobile.vue?vue&type=template&id=07239b9f&"
import script from "./menuMobile.vue?vue&type=script&lang=js&"
export * from "./menuMobile.vue?vue&type=script&lang=js&"
import style0 from "./menuMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VBottomNavigation } from 'vuetify/lib/components/VBottomNavigation';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBadge,VBottomNavigation,VBtn})
